ion-list {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  display: block;
  contain: content;
  list-style-type: none;
}

ion-list.list-inset {
  transform: translateZ(0);
  overflow: hidden;
}

.list-md {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 8px;
  padding-bottom: 8px;
  background: var(--ion-item-background, var(--ion-background-color, #fff));
}

@supports (inset-inline-start: 0) {
  .list-md > .input:last-child::after {
    inset-inline-start: 0;
  }
}
@supports not (inset-inline-start: 0) {
  .list-md > .input:last-child::after {
    left: 0;
  }
  :host-context([dir=rtl]) .list-md > .input:last-child::after {
    left: unset;
    right: unset;
    right: 0;
  }
  [dir=rtl] .list-md > .input:last-child::after {
    left: unset;
    right: unset;
    right: 0;
  }
  @supports selector(:dir(rtl)) {
    .list-md > .input:last-child::after:dir(rtl) {
      left: unset;
      right: unset;
      right: 0;
    }
  }
}

.list-md.list-inset {
  -webkit-margin-start: 16px;
  margin-inline-start: 16px;
  -webkit-margin-end: 16px;
  margin-inline-end: 16px;
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 2px;
}

.list-md.list-inset ion-item:first-child {
  --border-radius: 2px 2px 0 0;
}

.list-md.list-inset ion-item:last-child {
  --border-radius: 0 0 2px, 2px;
  --border-width: 0;
  --inner-border-width: 0;
}

.list-md.list-inset + ion-list.list-inset {
  margin-top: 0;
}

.list-md-lines-none .item-lines-default {
  --inner-border-width: 0px;
  --border-width: 0px;
}

.list-md-lines-full .item-lines-default {
  --inner-border-width: 0px;
  --border-width: 0 0 1px 0;
}

.list-md-lines-inset .item-lines-default {
  --inner-border-width: 0 0 1px 0;
  --border-width: 0px;
}

ion-card .list-md {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 0;
}